module.exports = __webpack_public_path__ + "img/screenshot-sim-perspective.cd6cee52.png";